/**
 * Converte valor string/number para float seguro.
 * Trata vírgulas como pontos decimais.
 */
export const parseNum = (v: any): number => {
    if (v === "" || v === null || v === undefined) return NaN;
    return Number(String(v).replace(",", "."));
};

/**
 * Máscara monetária: os dígitos entram da direita para a esquerda,
 * as 2 últimas posições são sempre as casas decimais.
 *
 * Exemplos de digitação sequencial:
 *   "1"    → "0,01"
 *   "12"   → "0,12"
 *   "123"  → "1,23"
 *   "1234" → "12,34"
 *   max    → "100,00"
 */
export const applyPercentMask = (value: string): string => {
    const digits = value.replace(/\D/g, "");
    if (!digits) return "";

    const num = Math.min(parseInt(digits, 10), 10000);
    const intPart = Math.floor(num / 100);
    const decPart = num % 100;

    return `${intPart},${String(decPart).padStart(2, "0")}`;
};
